import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CropperSettings } from 'ng2-img-cropper';
import * as _ from 'lodash';
@Component({
  
  selector: 'fsr-show-image-profile',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'show-image-profile.component.html',
  styleUrls: ['show-image-profile.component.scss']
})

export class ShowImageProfileComponent implements OnInit, OnDestroy {
  dialog: MatDialogRef<any>;
  personalInformation: any = {};
  selectedCommunity: any = {};
  selectedProperty: any = {};
  isSaving = false;
  isFileOver = false;
  idName = 'image-selector';
  data: any;
  cropperSettings: CropperSettings;
  dataUserImage: string;


  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private dataImage: any) {
    if (dataImage) {
      this.dataUserImage = dataImage.userProfileImage;
    }
    this.dialog = dialogRef;
    this.cropperSettings = new CropperSettings();
    this.cropperSettings.width = 250;
    this.cropperSettings.height = 250;
    this.cropperSettings.croppedWidth = 250;
    this.cropperSettings.croppedHeight = 250;
    this.cropperSettings.canvasWidth = 500;
    this.cropperSettings.canvasHeight = 300;
    this.cropperSettings.noFileInput = true;
    // TODO: Uncoment this line whe library solve issue with shaded area. https://github.com/cstefanache/angular2-img-cropper/issues/86
    //this.cropperSettings.rounded = true;
    this.data = {};
  }

  ngOnInit() {}

  ngOnDestroy() {}
}
